import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: 'createCommunityMember',
      method: 'post',
      request: (communityMember, callback, rejectCallback) => ({
        url: apiRoutes.createCommunityMember(),
        body: communityMember,
        meta: {
          callback,
          rejectCallback,
        },
      }),
    },
  ])(ComposedComponent);
